import NM from "@/utils/NM";
import { forceDescriptives, Interval } from "@/utils/normalDist";

// excel sheet2 裡有 mean 跟 sd
const getNMByExcelVal = (mean: number, sd: number, category: keyof Interval): NM => {
  const { newList } = forceDescriptives(mean, sd, category)
  const nm = new NM(newList)
  return nm
}

export const AGE_ATVM_NM = getNMByExcelVal(65.95, 2.03, "AGE");
export const AGE_PTVM_NM = getNMByExcelVal(56.71, 5.63, "AGE");
export const AGE_LSC_NM = getNMByExcelVal(50.16, 5.76, "AGE");
export const AGE_ULS_NM = getNMByExcelVal(48.42, 6.62, "AGE");
export const AGE_SLFF_NM = getNMByExcelVal(62.17, 6.81, "AGE");
export const AGE_LEFORT_NM = getNMByExcelVal(74.08, 3.07, "AGE");

export const BMI_ATVM_NM = getNMByExcelVal(25.91, 2.17, "BMI");
export const BMI_PTVM_NM = getNMByExcelVal(13.57, 7.12, "BMI");
export const BMI_LSC_NM = getNMByExcelVal(23.13, 2.67, "BMI");
export const BMI_ULS_NM = getNMByExcelVal(22.72, 2.95, "BMI");
export const BMI_SLFF_NM = getNMByExcelVal(24.19, 2.70, "BMI");
export const BMI_LEFORT_NM = getNMByExcelVal(22.31, 4.03, "BMI");

export const ANTERIOR_ATVM_NM = getNMByExcelVal(4.07, 1.81, "ANTERIOR");
export const ANTERIOR_PTVM_NM = getNMByExcelVal(-0.149, 0.77, "ANTERIOR");
export const ANTERIOR_LSC_NM = getNMByExcelVal(2.79, 2.34, "ANTERIOR");
export const ANTERIOR_ULS_NM = getNMByExcelVal(0.64, 0.98, "ANTERIOR");
export const ANTERIOR_SLFF_NM = getNMByExcelVal(3.88, 1.93, "ANTERIOR");
export const ANTERIOR_LEFORT_NM = getNMByExcelVal(6.42, 1.02, "ANTERIOR");

export const CENTRAL_ATVM_NM = getNMByExcelVal(6.24, 3.51, "CENTRAL");
export const CENTRAL_PTVM_NM = getNMByExcelVal(1.94, 4.29, "CENTRAL");
export const CENTRAL_LSC_NM = getNMByExcelVal(5.85, 4.49, "CENTRAL");
export const CENTRAL_ULS_NM = getNMByExcelVal(2.82, 3.98, "CENTRAL");
export const CENTRAL_SLFF_NM = getNMByExcelVal(8.17, 2.33, "CENTRAL");
export const CENTRAL_LEFORT_NM = getNMByExcelVal(9.93, 2.62, "CENTRAL");

export const POSTERIOR_ATVM_NM = getNMByExcelVal(1.27, 1.315, "POSTERIOR");
export const POSTERIOR_PTVM_NM = getNMByExcelVal(3.66, 1.876, "POSTERIOR");
export const POSTERIOR_LSC_NM = getNMByExcelVal(0.975, 1.4, "POSTERIOR");
export const POSTERIOR_ULS_NM = getNMByExcelVal(0.0727, 0.358, "POSTERIOR");
export const POSTERIOR_SLFF_NM = getNMByExcelVal(0.91157, 0.721, "POSTERIOR");
export const POSTERIOR_LEFORT_NM = getNMByExcelVal(4.16717, 3.06825, "POSTERIOR");


const allNM = {
  AGE_ATVM_NM,
  AGE_PTVM_NM,
  AGE_LSC_NM,
  AGE_ULS_NM,
  AGE_SLFF_NM,
  AGE_LEFORT_NM,

  BMI_ATVM_NM,
  BMI_PTVM_NM,
  BMI_LSC_NM,
  BMI_ULS_NM,
  BMI_SLFF_NM,
  BMI_LEFORT_NM,

  ANTERIOR_ATVM_NM,
  ANTERIOR_PTVM_NM,
  ANTERIOR_LSC_NM,
  ANTERIOR_ULS_NM,
  ANTERIOR_SLFF_NM,
  ANTERIOR_LEFORT_NM,

  CENTRAL_ATVM_NM,
  CENTRAL_PTVM_NM,
  CENTRAL_LSC_NM,
  CENTRAL_ULS_NM,
  CENTRAL_SLFF_NM,
  CENTRAL_LEFORT_NM,

  POSTERIOR_ATVM_NM,
  POSTERIOR_PTVM_NM,
  POSTERIOR_LSC_NM,
  POSTERIOR_ULS_NM,
  POSTERIOR_SLFF_NM,
  POSTERIOR_LEFORT_NM,
}

export default allNM;
